import ToggleInput from "./inputs/ToggleInput";
import {useEffect ,useState} from "react";
import {AnimatePresence, motion} from 'framer-motion';
import unidecode from "unidecode-plus";
import PencilIcon from "../images/icons/pencil.svg";
import TokenIcon from '../images/icons/promptus-token.svg';
import HistoryIcon from '../images/icons/history.svg'
import AdvancedSettingsIcon from '../images/icons/advanced-settings-expand-arrow.svg';
import {useGenerateDispatch, useGenerateStatus} from "../context/GenerateContext";
import {usePromptusAPIState, usePromptusAPIDispatch} from "../context/PromptusAPIContext";
import { useDriverContext, useDriverContextDispatch } from "../context/DriverContext";
import { useCollectionContext, useCollectionContextDispatch } from "../context/CollectionContext";
import { useAccountContext } from "../context/AccountContext";
import ImageUpload from "./ImageUpload";
import {db} from "../db";
import DrawingInput from "./inputs/DrawingInput";
import CloseIcon from "../images/icons/white-close.svg";
import PromptHistory from "./PromptHistory";
import {getLoras, getModels, getServerStatus, revealLocator, isLocalServerBusy,getRecommendedSettings} from "../api-helper";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import HowToIconActive from "../images/icons/nav-icons/nav-icon-how-to-active.svg";
import RecordingIcon from "../images/icons/input-bar-icons/icon-input-bar-voice.svg";
import StopRecordingIcon from "../images/icons/input-bar-icons/icon-input-bar-voice-recording.svg";
import AccountIcon from "../images/icons/promptus-profile-pic.svg";
import RefreshIcon from "../images/icons/refresh.svg";
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { usePromptContext } from '../context/PromptContext';
import { isUndefined } from "cropperjs";
import Select from 'react-select';
import makeAnimated from 'react-select/animated'
import Image from "image-js";

const schedulerOptions = [
    'Linear Multistep Scheduler',
    'Denoising Diffusion Implicit',
    'DPM-Solver',
    'Euler 2',
    'Pseudo Numerical',
    'Denoising Diffusion Probabilistic',
    'Ancestral Euler',
    'LCM'
];

function AnimatedInputGroup(props) {
    return (
        <motion.div
        variants={{ collapsed: { opacity: 0, height: 0 }, open: { opacity: 1, height: 'auto' } }}
        transition={{ duration: 0.2, delay: 0.2 }}
        id={props.id || ''}
        className={props.className || ''}
        >
            {props.children}
        </motion.div>
    )
}

const data = [
    { "model": "(SH) Stable Cascade 2.0", "steps": "12", "guidance": "7.5", "imageCount": "1", "imageWidth": "1024", "imageHeight": "1024", "scheduler": "DPM-Solver", "tile": "0", "shuffle": "0", "upscale": "0" },
    { "model": "sd_xl_turbo_1.0.safetensors", "steps": "2", "guidance": "0", "imageCount": "1", "imageWidth": "512", "imageHeight": "512", "scheduler": "LCM", "tile": "0", "shuffle": "0", "upscale": "0" },
    { "model": "(SH) AlbedoBase XL", "steps": "20", "guidance": "7.5", "imageCount": "1", "imageWidth": "512", "imageHeight": "512", "scheduler": "DPM-Solver", "tile": "0", "shuffle": "0", "upscale": "0" },
    { "model": "(SH) Animagine XL", "steps": "20", "guidance": "7.5", "imageCount": "1", "imageWidth": "1024", "imageHeight": "1024", "scheduler": "DPM-Solver", "tile": "0", "shuffle": "0", "upscale": "0" },
    { "model": "(SH) Anime Illust Diffusion XL", "steps": "20", "guidance": "7.5", "imageCount": "1", "imageWidth": "1024", "imageHeight": "1024", "scheduler": "DPM-Solver", "tile": "0", "shuffle": "0", "upscale": "0" },
    { "model": "(SH) DreamShaper XL", "steps": "20", "guidance": "7.5", "imageCount": "1", "imageWidth": "1024", "imageHeight": "1024", "scheduler": "DPM-Solver", "tile": "0", "shuffle": "0", "upscale": "0" },
    { "model": "(SH) ICBINP XL", "steps": "20", "guidance": "7.5", "imageCount": "1", "imageWidth": "1024", "imageHeight": "1024", "scheduler": "DPM-Solver", "tile": "0", "shuffle": "0", "upscale": "0" },
    { "model": "(SH) Juggernaut XL", "steps": "20", "guidance": "7.5", "imageCount": "1", "imageWidth": "1024", "imageHeight": "1024", "scheduler": "DPM-Solver", "tile": "0", "shuffle": "0", "upscale": "0" },
    { "model": "(SH) Pony Diffusion XL", "steps": "20", "guidance": "7.5", "imageCount": "1", "imageWidth": "1024", "imageHeight": "1024", "scheduler": "DPM-Solver", "tile": "0", "shuffle": "0", "upscale": "0" },
    { "model": "sd_xl_base_1.0.safetensors", "steps": "20", "guidance": "7.5", "imageCount": "1", "imageWidth": "1024", "imageHeight": "1024", "scheduler": "DPM-Solver", "tile": "0", "shuffle": "0", "upscale": "0" },
    { "model": "sd3_medium_incl_clips.safetensors", "steps": "30", "guidance": "7.5", "imageCount": "1", "imageWidth": "1024", "imageHeight": "1024", "scheduler": "DPM-Solver", "tile": "0", "shuffle": "0", "upscale": "0" },
];

async function addRecommendedSettings(db, data) {
    // Ensure the database is ready
    await db.open();

    for (const item of data) {
        let model = item.model.trim();

        try {
            const existingSetting = await db.recommendedSettings
                .where('model')
                .equals(model)
                .first();

            if (existingSetting === undefined) {
                const setting = {
                    model: model,
                    steps: parseFloat(item.steps),
                    guidance: parseFloat(item.guidance),
                    imageCount: parseInt(item.imageCount),
                    imageWidth: parseInt(item.imageWidth),
                    imageHeight: parseInt(item.imageHeight),
                    scheduler: item.scheduler.trim(),
                    tile: parseInt(item.tile),
                    shuffle: parseInt(item.shuffle),
                    upscale: parseInt(item.upscale)
                };

                try {
                    await db.recommendedSettings.add(setting);
                } catch (error) {
                    console.error('Error adding setting:', error);
                }
            }
        } catch (error) {
            console.error('Error checking existing setting:', error);
        }
    }
}

// Call the function and pass the db and data
addRecommendedSettings(db, data).then(() => {
    console.log("All settings processed");
}).catch(error => {
    console.error("Error processing settings:", error);
});

async function addOrUpdateRecommendedSettings() {
    try {
        const settings = await getRecommendedSettings();

        await db.transaction('rw', db.recommendedSettings, async () => {
            for (const setting of settings) {
                const existingSetting = await db.recommendedSettings.get({ model: setting.model });

                const dbSetting = {
                    model: setting.model,
                    steps: parseFloat(setting.steps),
                    guidance: parseFloat(setting.guidance),
                    imageCount: parseInt(setting.image_count),
                    imageWidth: parseInt(setting.image_width),
                    imageHeight: parseInt(setting.image_height),
                    scheduler: setting.scheduler,
                    tile: parseInt(setting.tile),
                    shuffle: parseInt(setting.shuffle),
                    upscale: parseInt(setting.upscale),
                };

                if (existingSetting) {
                    // Update the existing setting
                    await db.recommendedSettings.update(existingSetting.id, dbSetting);
                } else {
                    // Add the new setting
                    await db.recommendedSettings.add(dbSetting);
                }
            }
        });

        console.log('All data successfully added or updated');
    } catch (error) {
        console.error('Error in fetching and adding settings:', error);
    }
}

addOrUpdateRecommendedSettings().then(() => {
    console.log("Process completed");
}).catch(error => {
    console.error("Error during the process:", error);
});

const animatedComponents = makeAnimated()

export default function PromptHeader(props) {
    let {defaultPrompt} = props;
    const generateStatus = useGenerateStatus();
    const generateStatusDispatch = useGenerateDispatch();
    const promptusAPIState = usePromptusAPIState();
    const promptusAPIDispatch = usePromptusAPIDispatch();
    const driverContext = useDriverContext();
    const driverContextDispatch = useDriverContextDispatch();
    const collectionContext = useCollectionContext();
    const collectionContextDispatch = useCollectionContextDispatch();
    const accountContext = useAccountContext();
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [settings, setSettings] = useState([]);
    const [inPaint, setInPaint] = useState(false);
    const [maskImage, setMaskImage] = useState(null);
    const [openHistory, setOpenHistory] = useState(false);
    const [controlnetDisplay, setControlnetDisplay] = useState("");
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [audioPrompt, setAudioPrompt] = useState("");
    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition
      } = useSpeechRecognition();
    const [options, setOptions] = useState([]);

    // Inputs
    const [promptOutput, setPromptOutput] = useState('text-image');
    const [submitPrompt, setSubmitPrompt] = useState(defaultPrompt.prompt.prompt);
    const [seed, setSeed] = useState(defaultPrompt.prompt.params.seed_value);
    const [negativeKeywords, setNegativeKeywords] = useState(defaultPrompt.prompt.negative_prompt);
    const [steps, setSteps] = useState(defaultPrompt.prompt.params.num_inference_steps);
    const [guidance, setGuidance] = useState(defaultPrompt.prompt.params.guidance_scale);
    const [imageCount, setImageCount] = useState(1);
    const [imageWidth, setImageWidth] = useState(defaultPrompt.prompt.params.width);
    const [imageHeight, setImageHeight] = useState(defaultPrompt.prompt.params.height);
    const [selectedModel, setSelectedModel] = useState(defaultPrompt.prompt.params.model);
    const [selectedScheduler, setSelectedScheduler] = useState(defaultPrompt.prompt.params.scheduler);
    const [tile, setTile] = useState(defaultPrompt.prompt.params.tile);
    const [shuffle, setShuffle] = useState(defaultPrompt.prompt.params.shuffle);
    const [upscale, setUpScale] = useState(defaultPrompt.prompt.params.upscale_factor);
    const [pix2pix, setPix2Pix] = useState(false);
    const [controlNet, setControlNet] = useState("");
    const [onlineState, setOnlineState] = useState(promptusAPIState.online);
    const [image, setImage] = useState(null);
    const [enhancePrompt, setEnhancePrompt] = useState(false);
    const [imageNets, setImageNets] = useState("");
    const [tag, setTag] = useState("");
    const [inputTag, setInputTag] = useState("");
    const [managerOpen, setManagerOpen] = useState(false);
    const [apiLocalGPU, setApiLocalGPU] = useState("");
    const [apiLocalCPU, setApiLocalCPU] = useState("");
    const [onceTime, setOnceTime] = useState(false);
    const [selectedLora, setSelectedLora] = useState("");
    const [loraWeight, setLoraWeight] = useState(0);
    const { contextSubmitPrompt } = usePromptContext();
    const [memePrompt, setMemePrompt] = useState("");


    const setPromptinalPrompts = (promptinal) => {
        let includeImages = false;
        let notFound = true;
        if (promptinal.generate.prompt) {
            setSubmitPrompt(promptinal.generate.prompt);
        }
        setSeed(promptinal.generate.seed);
        setNegativeKeywords(promptinal.generate.negative_prompt);
        setSelectedLora(promptinal.generate.lora);
        setSelectedScheduler(promptinal.generate.scheduler);
        setSteps(promptinal.generate.num_inference_steps);
        setGuidance(promptinal.generate.guidance_scale);
        setImageCount(1);
        setImageWidth(promptinal.generate.width);
        setImageHeight(promptinal.generate.height);
        promptusAPIState.models.map(model => {
            if (promptinal.generate.model == model) {
                setSelectedModel(model);
                notFound = false;
            }
        })
        if (notFound) {
            Swal.fire({
                title: "Model not found",
                text: "The model you are trying to use is not available. Please select another model.",
                icon: "error",
                timer: 1500,
                showConfirmButton: false
            }).then(() => {
                setSettingsOpen(true);
                setSelectedModel("stable-diffusion-v1-5");
            });
        }
        setTile(promptinal.generate.tile);
        setShuffle(false);
        // setUpScale(promptinal.generate.upscale);
        if (promptinal.sources.source_image && includeImages) {
            setImage(promptinal.sources.source_image);
            setControlNet(promptinal.sources.control_net);
        }
        if (promptinal.sources.mask_image) {
            // setMaskImage(promptinal.sources.mask_image); // Nice to have when functional
        }
    }

    const openFile = (imageData) => {
        let imageDetails;
        try {
            imageDetails = JSON.parse(imageData);
        } catch (error) {
            console.error("Error opening file: ", error)
        }
        console.log("Image details: ", imageDetails);
        if (imageDetails['Promptus v1.0']) {
            setPromptinalPrompts(imageDetails['Promptus v1.0']);
        } else {
            setWholePrompt(imageDetails, false, true);
        }
    };

    /**
     * Get the server
     * @returns {Promise<*>}
     */
        const getServer = async () => {
            return await db.settings
                .where("key")
                .equals("api_host")
                .first(setting => setting.value)
        }

    useEffect(() => {
        let retainedPrompt;
        try {
            retainedPrompt = JSON.parse(localStorage.getItem("Generate"))
        } catch (error) {
            console.error("Error fetching the saved prompt: ", error)
        }
        if (retainedPrompt) {
            setSubmitPrompt(retainedPrompt.prompt);
            setEnhancePrompt(retainedPrompt.enhancePrompt);
            setSeed(retainedPrompt.seed);
            setNegativeKeywords(retainedPrompt.negativeKeywords);
            setSteps(retainedPrompt.steps);
            setGuidance(retainedPrompt.guidance);
            setImageCount(retainedPrompt.imageCount);
            setImageWidth(retainedPrompt.imageWidth);
            setImageHeight(retainedPrompt.imageHeight);
            setSelectedModel(retainedPrompt.selectedModel);
            setSelectedScheduler(retainedPrompt.selectedScheduler);
            setTile(retainedPrompt.tile);
            setShuffle(retainedPrompt.shuffle);
            setUpScale(retainedPrompt.upscale);
        }
        db.settings.toArray(settings => {
            settings.forEach(setting => {
                switch(setting.key) {
                    case "local_gpu":
                        setApiLocalGPU(setting.value);
                        break;
                    case "local_cpu":
                        setApiLocalCPU(setting.value);
                        break;                     
                    default:
                        // do nothing.
                        return;
                }
            });
        });

        setOptions(promptusAPIState.models.map(model => ({ value: model, label: model })));
    },[])    

    /**
     * Get the login method
     * @returns {Promise<*>}
     */
    const checkServer = async (localhost) => {
        if (localhost === apiLocalGPU) {
            db.settings.put({key: 'api_host', value: apiLocalGPU})
            // promptusAPIDispatch({type: 'setHost', host: apiLocalCPU});
            return apiLocalGPU
        } else if (localhost === apiLocalCPU) {
            db.settings.put({key: 'api_host', value: apiLocalCPU})
            // promptusAPIDispatch({type: 'setHost', host: apiLocalGPU});
            return apiLocalCPU
        }
    }

    const toggleOffline = (checked) => {
        generateStatusDispatch({type: 'clearError'});
        if (checked) {
            promptusAPIDispatch({type: 'online'});
            fetchModels();
        } else {
            db.settings.where("key").equals("api_host").count().then(count => { 
                if (count !== 0) {
                    getServer().then(apihost => {
                        let localhost = apihost
                        if (localhost == "") {
                            if (apiLocalGPU !== "") {
                                localhost = apiLocalGPU
                            } else if (apiLocalCPU !== "") {
                                localhost = apiLocalCPU
                            }
                        }
                        if (localhost !== undefined) {
                            fetch(localhost, {mode: "no-cors"})
                            .then(res => {
                                promptusAPIDispatch({type: 'offline'});
                                if (localhost === apiLocalGPU) {
                                    promptusAPIDispatch({type: 'setActiveGPU', server: true})
                                } else if (localhost === apiLocalCPU) {
                                    promptusAPIDispatch({type: 'setActiveCPU', server: true})
                                }
                            })
                            .catch(err => {
                                checkServer(localhost)
                                .then((secondHost) => {
                                    fetch(secondHost, {mode: "no-cors"})
                                    .then((res) => {
                                        promptusAPIDispatch({type: 'offline'});
                                        if (secondHost === apiLocalGPU) {
                                            promptusAPIDispatch({type: 'setActiveGPU', server: true})
                                        } else if (secondHost === apiLocalCPU) {
                                            promptusAPIDispatch({type: 'setActiveCPU', server: true})
                                        } 
                                        fetchModels();
                                    })
                                    .catch((err) => {
                                        Swal.fire({
                                            title: "Check local server",
                                            text: "The local server was not found. Please open promptus manager to start the server.",
                                            icon: "error",
                                            confirmButtonText: "Ok",
                                            confirmButtonColor: "#FFB02E",
                                            showDenyButton: true,
                                            denyButtonText: "Open Manager",
                                            denyButtonColor: "#190A4E"
                                        }).then((result) => {
                                            if (result.isDenied) {
                                                if (managerOpen == true) {
                                                    window.location.replace(`${window.location.href}?accountNo=${accountContext.accountDetails.accountNo}`)
                                                } else {
                                                    window.location.replace(`promptus-pm:/accountNo=${accountContext.accountDetails.accountNo}`)
                                                }
                                            }
                                        })
                                    })
                                })
                            })
                        }
                    })
                } else {
                    Swal.fire({
                        title: "Save your server settings",
                        text: "Your server settings is not saved onto the app. Please do so before proceeding.",
                        icon: "error",
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#FFB02E"
                    })
                }
            }) 
        }
    }

    const help = (e) => {
        const driver = new Driver({
            onReset: () => {driverContextDispatch({type: 'off'});}
        });
        driverContextDispatch({type: 'on'});
        setTimeout(() => { 
            helpOverlays(e, driver);
            if (driverContext.advanced == true) {
                driver.start(9);
            }
            if (driverContext.controlNet == true) {
                driver.start(19);
            }
            if (driverContext.advanced == false && driverContext.controlNet == false) {
                driver.start();
            }               
        }, 1)      
    } 

    const handleUpscale = (value) => {
        if (Number(value) === 6) {
            setUpScale(8);
            return;
        }
        if (Number(value) >= 2) {
            setUpScale(Number(value));
        }
        if (Number(value) < 2){
            setUpScale(0);
        }
    }

    useEffect(() => {
        if (pix2pix || controlNet) {
            setUpScale(0);
        }
    }, [controlNet, pix2pix])

    useEffect(() =>{
       if (contextSubmitPrompt.length > 0) setSubmitPrompt(contextSubmitPrompt);
    });



    useEffect(() => {
        if (maskImage) {
            setPromptOutput("image-in-paint");
        }
        if (image && !maskImage) {
            setPromptOutput("image-image")
        }
    }, [maskImage, image])

    /*useEffect(() => {
        if (selectedModel.toLowerCase().includes("xl")) {
            if (selectedModel.toLowerCase().includes("turbo")) {
                setImageWidth(512)
                setImageHeight(512)
                setSteps(2)
                setGuidance(0)
                setSelectedScheduler("LCM")
            } else {
                setImageWidth(1024)
                setImageHeight(1024)
                setGuidance(7.5)
                setSteps(20)
                setSelectedScheduler("DPM-Solver")
            }
        } else if (selectedModel.toLowerCase().includes("cascade")) {
            setImageHeight(1024)
            setImageWidth(1024)
        } 
        else {
            setImageWidth(512)
            setImageHeight(512)
            setGuidance(7.5)
            setSteps(12)
            setSelectedScheduler("DPM-Solver")
        }
    },[selectedModel])
     */

    useEffect(() => {
        if (selectedLora.toLowerCase().includes("lightning")) {
            setGuidance(0)
            if (selectedLora.toLowerCase().includes("2step")) {
                setSteps(2)
                setSelectedScheduler("LCM")
            } else if (selectedLora.toLowerCase().includes("4step")) {
                setSteps(4)
                setSelectedScheduler("DPM-Solver")
            } else if (selectedLora.toLowerCase().includes("8step")) {
                setSteps(8)
                setSelectedScheduler("DPM-Solver")
            }
        }
    }, [selectedLora])

    useEffect(() => {
        if (controlNet !== "") {
            setImageNets("");
        }
        setControlnetDisplay(controlNet)
        if (controlNet === 'mlsd') {
            setControlnetDisplay("Straight Lines")
        }

        if (controlNet === 'pose-to-image') {
            setControlnetDisplay("Pose to Image")
        }
    }, [controlNet])

    useEffect(() => {
        if (promptOutput !== "text-image") {
            setImageNets(promptOutput);
        }

        if (promptOutput === 'image-in-paint') {
            setImageNets("In-Paint Image")
            setSelectedModel("stable-diffusion-inpainting")
        }

        if (promptOutput === 'image-image') {
            setImageNets("Image to Image")
            if (promptusAPIState.online) {
                setSelectedModel("(AI-Horde) Stable Cascade 1.0")
            }
        }
    }, [promptOutput])


    useEffect(() => {
        (async () => { await db.settings.toArray(settings => setSettings(settings)); })();
        if (generateStatus.status === "loading" && submitPrompt.length === 0) {
            (async () => { await db.collection.where('uid').equals(generateStatus.uid).toArray(prompts => {
                if (prompts.length > 0) {
                    setWholePrompt(prompts[0].prompt, false, true);
                }
            })})();
        }
    }, []);

    useEffect( () => {
        if (generateStatus.status === "error" && generateStatus.message === "Out of Credits") {
            Swal.fire({
                title: "Credits Error",
                html: `You are Out of Credits. Please click <a style="color:blue" href="${process.env.REACT_APP_PROMPTUS_MAIN_WEBSITE_LIVE}/payments" target="_blank" rel="noopener noreferrer">here</a> to top up.`,
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E"
            })
        }
    },[generateStatus])

    const setWholePrompt = (prompt, history, includeImages = false) => {
        console.log("setWholePrompt", prompt);
        let imageDetails;
        let notFound = true;
        if (history) {
            setSubmitPrompt(prompt)
        } else {
            if (typeof(prompt.prompt.prompt) === "string"){
                imageDetails = prompt.prompt;
            } else if (typeof(prompt.prompt.prompt) === "object"){
                imageDetails = prompt.prompt.prompt;
            }
            setSubmitPrompt(imageDetails.prompt);
            setNegativeKeywords(imageDetails.negative_prompt);
            setSelectedLora(imageDetails.params.lora);
            setSelectedScheduler(imageDetails.params.scheduler);
            setSteps(imageDetails.params.num_inference_steps);
            setGuidance(imageDetails.params.guidance_scale);
            setImageCount(imageDetails.params.count);
            setImageWidth(imageDetails.params.width);
            setImageHeight(imageDetails.params.height);
            promptusAPIState.models.map(model => {
                if (imageDetails.params.model == model) {
                    setSelectedModel(model);
                    notFound = false;
                }
            })
            if (notFound) {
                Swal.fire({
                    title: "Model not found",
                    text: "The model you are trying to use is not available. Please select another model.",
                    icon: "error",
                    timer: 1500,
                    showConfirmButton: false
                }).then(() => {
                    setSettingsOpen(true);
                    setSelectedModel("stable-diffusion-v1-5");
                });
            }
            
            const tileValue = imageDetails.params.tile;
            if (typeof tileValue === 'number') {
                setTile(false);
            } else if (tileValue== "0" || tileValue.toLowercase() == "false" || tileValue== false || tileValue== "" || tileValue== "n/p") {
                setTile(false);
            } else {
                setTile(true);
            }

            const shuffleValue = imageDetails.params.shuffle;
            if (typeof shuffleValue === 'number') {
                setShuffle(false);
            } else if (shuffleValue == "0" || shuffleValue.toLowercase() == "false" || shuffleValue == false || shuffleValue == "" || shuffleValue == "n/p") {
                setShuffle(false);
            } else {
                setShuffle(true);
            }
            // setUpScale(imageDetails.params.upscale);
            if (imageDetails.params.input_image && includeImages) {
                setImage(imageDetails.params.input_image);
                setControlNet(imageDetails.params.control_net);
            }
            if (imageDetails.params.mask_image) {
                // setMaskImage(imageDetails.params.mask_image); // Nice to have when functional
            }
        }
    };

    const setSeedPrompt = (prompt, seed) => {
        setSubmitPrompt(prompt);
        setSeed(seed);
    }

    const handleAdvancedSettings = () => {
        setSettingsOpen(!settingsOpen)
        if (settingsOpen === false) {
            driverContextDispatch({type: 'advanced'});
        }
        if (settingsOpen === true) {
            driverContextDispatch({type: 'reset'});
        }
    }

    useEffect(() => {
        let {uid} = generateStatus;
        
        if (props.uid && !uid) {
            uid = props.uid;
        }
        if (uid) {
            (async () => await db.collection.where("uid").equals(uid).first(promptDetails => {
                console.log("Prompt Details From Prompt Click:", promptDetails);
                setSubmitPrompt(promptDetails.prompt.prompt.prompt);
                setWholePrompt(promptDetails.prompt, false);
            }))();
        }
    }, [props.uid, generateStatus.uid])

    useEffect(() => {
        if (props.prompt && props.prompt !== "") {
            db.images.where("hash").equals(props.prompt).first(imageDetails => {
                console.log("Image Details From Prompt Click:", imageDetails);
                setSubmitPrompt(imageDetails.prompt);
                setSelectedModel(imageDetails.model);
                (async () => await Image.load(`data:image/*;base64,${imageDetails.image}`).then((image) => {
                    setImageWidth(Number(image.width));
                    setImageHeight(Number(image.height));
                }))();
            })
        }
    }, [props.prompt])

    useEffect(() => {
        if (props.seed) {
            setSeed(props.seed);
        }
    }, [props.seed]);

    useEffect(() => {
        if (props.inputImage) {
            setImage(props.inputImage.image);
        }
        if (collectionContext.collectionImage !== null) {
            setImage(collectionContext.collectionImage.image)
        }
    }, [props.inputImage, collectionContext.collectionImage])

    // useEffect(() => {
    //     if (inputTag !== "") {
    //         setTag("")
    //     }
        
    //     if (tag !== "") {
    //         setInputTag("")
    //     }
    // },[tag, inputTag])

    const fetchModels = async() => {
        await getModels(promptusAPIState, generateStatusDispatch)
        .then(async data => {
            console.log("Retrieved models data:", data); // Add this log

            let models = data.models;
            let filters = [];

            let setting = await db.settings.get({key: 'use_aihorde_models'});
            console.log("use_aihorde_models setting:", setting);
           // if (setting) filters.push("Dall-e");

            setting = await db.settings.get({key: 'use_openai_models'});
            console.log("use_openai_models setting:", setting);
            //if (setting) filters.push("(SH)");

            console.log("Filters array:", filters);
            console.log("Models pre filter", models);

            if (filters.length > 0) {
                try {
                    models = models.filter(model => {
                        console.log("Filtering model:", model); // Log each model being filtered
                        const includesFilter = filters.some(filter => model.includes(filter));
                        console.log(`Model includes filter (${includesFilter}):`, model);
                        return !includesFilter;
                    });
                } catch (error) {
                    console.error("Error during filtering:", error); // Capture any errors during filtering
                }
            }

            console.log("Models post filter", models);

            promptusAPIDispatch({type: 'setModels', models: models});
            setOptions(models.map(model => ({ value: model, label: model })));
        })
        .catch(error => {
            console.error("Error in getModels:", error); // Add this log to catch errors
            promptusAPIDispatch({type: 'setModels', models: []});
        });
    }

    useEffect(() => {
        (async () => {
            if (promptusAPIState.host) {
                fetchModels();

                await getLoras(promptusAPIState, generateStatusDispatch)
                .then(data => {
                    promptusAPIDispatch({type: 'setLoras', loras: data.loras});
                })
                .catch(() => promptusAPIDispatch({type: 'setLoras', models: []}));
            }
        })();
        setOnlineState(promptusAPIState.online);
    }, [promptusAPIState.host]);

    useEffect(() => {
        if (
            (generateStatus.loading && settingsOpen) ||
            (generateStatus.status === 'done' && settingsOpen)
        ) {
            setSettingsOpen(false);
        }
        if (generateStatus.status === 'done') {
            setEnhancePrompt(false);
        }
        if (image && !generateStatus.loading && generateStatus.status === 'ready') {
            setSettingsOpen(true);
        }
    }, [generateStatus.loading, generateStatus.status, image]);

    const handleClearParams = () => {
        setSubmitPrompt(defaultPrompt.prompt.prompt);
        setSeed(defaultPrompt.prompt.params.seed_value);
        setNegativeKeywords(defaultPrompt.prompt.negative_prompt);
        setSteps(defaultPrompt.prompt.params.num_inference_steps);
        setGuidance(defaultPrompt.prompt.params.guidance_scale);
        setImageCount(1);
        setImageWidth(defaultPrompt.prompt.params.width);
        setImageHeight(defaultPrompt.prompt.params.height);
        setSelectedModel(defaultPrompt.prompt.params.model);
        setSelectedScheduler(defaultPrompt.prompt.params.scheduler);
        setTile(defaultPrompt.prompt.params.tile);
        setShuffle(defaultPrompt.prompt.params.shuffle);
        setUpScale(defaultPrompt.prompt.params.upscale_factor)
        setImage(null);
        setControlNet("");
        setMaskImage(null);
        setInPaint(false);
        setPromptOutput("text-image");
        driverContextDispatch({type: 'advanced'});
        setImageNets("");
    }

    const getCategorySetting = async () => {
        return await db.settings
        .where("key")
        .equals("category_popup")
        .first(setting => setting.value)
    }

    const setRevealPrompt = (prompt) => {
        console.log("setRevealPrompt", prompt);
        let notFound = true;
        let includeImages = false;

        if (prompt.prompt) {
            setSubmitPrompt(prompt.prompt);
        }
        setSeed(prompt.seed);
        setNegativeKeywords(prompt.negative_prompt);
        setSelectedLora(prompt.lora);
        setSelectedScheduler(prompt.scheduler);
        setSteps(prompt.num_inference_steps);
        setGuidance(prompt.guidance_scale);
        setImageCount(1);
        let dimensions = prompt.image_size.split("x");
        setImageWidth(dimensions[0]);
        setImageHeight(dimensions[1]);
        setSelectedModel(prompt.model);
        // promptusAPIState.models.map(model => {
        //     if (prompt.model == model) {
        //         setSelectedModel(model);
        //         notFound = false;
        //     }
        // })
        // if (notFound) {
        //     Swal.fire({
        //         title: "Model not found",
        //         text: "The model you are trying to use is not available. Please select another model.",
        //         icon: "error",
        //         timer: 1500,
        //         showConfirmButton: false
        //     }).then(() => {
        //         setSettingsOpen(true);
        //         setSelectedModel("stable-diffusion-v1-5");
        //     });
        // }
        if (prompt.tile == "0" || prompt.tile.toLowercase() == "false" || prompt.tile == false || prompt.tile == "" || prompt.tile == "n/p") {
            setTile(false);
        } else {
            setTile(true);
        }
        if (prompt.shuffle == "0" || prompt.shuffle.toLowercase() == "false" || prompt.shuffle == false || prompt.shuffle == "" || prompt.shuffle == "n/p") {
            setShuffle(false);
        } else {
            setShuffle(true);
        }
        // setUpScale(prompt.upscale);
        if (prompt.input_image && includeImages) {
            setImage(prompt.input_image);
            setControlNet(prompt.control_net);
        }
        if (prompt.mask_image) {
            // setMaskImage(prompt.mask_image); // Nice to have when functional
        }
    }

    const checkHostbeforeGenerate = () => {
        if (promptusAPIState.host.includes("localhost")) {
            return false;
        } else if (promptusAPIState.host.includes("promptus")) {
            return true;
        }
    }

    const handleTagModal = () => {
        console.log("generate buttton pressed");
        if (accountContext.loggedIn) {
            getCategorySetting().then(async categoryBool => {
                if (submitPrompt) {
                    // let amount = imageCount * 5
                    // if (accountContext.accountDetails.tokens - amount < 0) {
                    //     Swal.fire({
                    //         color: "£190A4E",
                    //         title: "Not enough tokens",
                    //         text: "You do not have enough tokens for the amount of images you are trying to generate",
                    //         icon: "error",
                    //         confirmButtonText: 'OK',
                    //         confirmButtonColor: "#FFB02E"
                    //     })
                    // } else {
                        if (checkHostbeforeGenerate() == false) {
                            await isLocalServerBusy(promptusAPIState).then(async(data) => {
                                console.log("Local server busy data: ", data);
                                if (data.busy == false || data.busy == "false") {
                                    if (submitPrompt.slice(-2) === "i0") {
                                        revealLocator(submitPrompt).then((response) => {
                                            console.log("response", response);
                                            setRevealPrompt(response["Promptinals v1.0"]);
                                        })
                                    } else {
                                        if ((selectedModel.includes("pix2pix") || selectedModel.includes("inpainting")) && (controlNet == "" || imageNets == "") && !image) {
                                            Swal.fire({
                                                title: "Generation Error",
                                                text: `There is no input image or control net being used for ${selectedModel} which is required for this model.`,
                                                icon: "error",
                                                confirmButtonText: "OK",
                                                confirmButtonColor: "#FFB02E",
                                            });
                                            return
                                        }
                                        if (categoryBool) {
                                            setOpen(true)
                                        } else {
                                            handleSubmitPrompt();
                                        }
                                    }
                                } else {
                                    Swal.fire({
                                        title: "Local server is busy",
                                        text: "Please try again later",
                                        icon: "error",
                                        confirmButtonText: "OK",
                                        confirmButtonColor: "#FFB02E",
                                    });
                                }
                            }).catch((e) => {
                                console.error("Local server is busy error", e);
                            });
                        } else {
                            if (submitPrompt.slice(-2) === "i0") {
                                revealLocator(submitPrompt).then((response) => {
                                    console.log("response", response);
                                    setRevealPrompt(response["Promptinals v1.0"]);
                                })
                            } else {
                                if ((selectedModel.includes("pix2pix") || selectedModel.includes("inpainting")) && (controlNet == "" || imageNets == "") && !image) {
                                    Swal.fire({
                                        title: "Generation Error",
                                        text: `There is no input image or control net being used for ${selectedModel} which is required for this model.`,
                                        icon: "error",
                                        confirmButtonText: "OK",
                                        confirmButtonColor: "#FFB02E",
                                    });
                                    return
                                }
                                if (categoryBool) {
                                    setOpen(true)
                                } else {
                                    handleSubmitPrompt();
                                }
                            }
                        }
                    // }
                } else {
                    Swal.fire({
                        color: "#190A4E",
                        title: "No Prompt",
                        icon: "error",
                        timer: 1500,
                        showConfirmButton: false
                    })
                }
            })
        } else {
            Swal.fire({
                color: "#190A4E",
                title: "Please register an account before generating images here",
                icon: "error",
                confirmButtonText: 'Register',
                confirmButtonColor: "#FFB02E",
                showDenyButton: true,
                denyButtonText: "Login",
                denyButtonColor: "#190A4E",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.open("https://signup.promptus.ai/", "_blank");
                }
                if (result.isDenied) {
                    navigate('/profile');
                }
            })
        }
    }

    const handleSubmitPrompt = () => {
        props.pageNumber(0);
        props.setCategory("All");
        let prompt_output = promptOutput;
        let testMode = false;
        if (settings.find(setting => setting.key === "test_mode")) testMode = settings.find(setting => setting.key === "test_mode").value;
        let safeMode = true;
        if (settings.find(setting => setting.key === "safe_mode")) safeMode = settings.find(setting => setting.key === "safe_mode").value;
        let lowMemory = true;
        if (settings.find(setting => setting.key === "low_memory")) lowMemory = settings.find(setting => setting.key === "low_memory").value;
        let fullPrecision = false;
        if (settings.find(setting => setting.key === "full_precision")) fullPrecision = settings.find(setting => setting.key === "full_precision").value;
        let halfModel = false;
        if (settings.find(setting => setting.key === "half_model")) halfModel = settings.find(setting => setting.key === "half_model").value;
        let cpuGeneration = false;
        if (settings.find(setting => setting.key === "cpu_generation")) cpuGeneration = settings.find(setting => setting.key === "cpu_generation").value;
        let cpuOffloading = false;
        if (settings.find(setting => setting.key === "cpu_offloading")) cpuOffloading = settings.find(setting => setting.key === "cpu_offloading").value;
        let batchNumber = 1;
        if (settings.find(setting => setting.key === "image_batch_size")) batchNumber = settings.find(setting => setting.key === "image_batch_size").value;

        defaultPrompt.low_memory_mode = lowMemory;
        defaultPrompt.safe_mode = safeMode;
        defaultPrompt.test_mode = testMode;
        defaultPrompt.full_precision = fullPrecision;
        defaultPrompt.half_model = halfModel;
        defaultPrompt.cpu_generation = cpuGeneration;
        defaultPrompt.cpu_offloading = cpuOffloading;
        defaultPrompt.image_batch_size = batchNumber;

        let promptParamsParams = {
            ...defaultPrompt.prompt.params,
            seed_value: seed,
            num_inference_steps: steps,
            guidance_scale: guidance,
            count: imageCount,
            width: imageWidth,
            height: imageHeight,
            model: selectedModel,
            lora: selectedLora,
            lora_scale: loraWeight,
            scheduler: selectedScheduler,
            tile,
            shuffle,
            upscale: !!upscale,
            upscale_factor: upscale ? upscale : '',
            input_image: image,
            safety_checker: safeMode,
            control_net: controlNet,
            mask_image: maskImage,
            pix2pix: pix2pix,
        };

        if (controlNet !== "" || pix2pix === true) {
            prompt_output = "image-image";
        }

        let promptParams = {
            ...defaultPrompt.prompt,
            prompt: unidecode(submitPrompt),
            negative_prompt: negativeKeywords,
            params: promptParamsParams,
            prompt_output: prompt_output,
            enhanced: enhancePrompt,
            meme_prompt: memePrompt
        };
        const generatePrompt = {...defaultPrompt, prompt: promptParams};
        generateStatusDispatch({type: 'loading'});
        getServerStatus(promptusAPIState, generateStatusDispatch)
        .then((data) => {props.handleGenerate(generatePrompt, false, null);});
    }

    const handleControlNetToggle = (checked, value) => {
        if (checked) {
            setControlNet(value);
        } else {
            setControlNet("");
        }
        setPix2Pix(false);
        setPromptOutput("text-image");
    }

    const addTagToImage = () => {
        console.log("add tag to image", tag, inputTag);
        if (tag !== "" && inputTag !== "") {
            let concactedString = tag + "," + inputTag;
            if (concactedString !== "") {
                console.log("concactedString", concactedString);
                generateStatusDispatch({type: 'tagging', tag:concactedString});
            }
        } else if (tag !== "" && inputTag === "") {
            generateStatusDispatch({type: 'tagging', tag:tag});
        } else if (tag === "" && inputTag !== "") {
            generateStatusDispatch({type: 'tagging', tag:inputTag});
        }
        setOpen(false)
        handleSubmitPrompt()
    }

    const handleKeyDown = (e) => {
        if (openHistory) {
            if (e.key === "Escape" || e.keyCode == 27) {
                setOpenHistory(false)
            }
        }
        if (e.key === "Enter") {
            if (open) {
                addTagToImage()
            } else {
                handleTagModal()
            }
        }
      }; 
    
    const conListen = () => {
        SpeechRecognition.startListening({ continuous: true })
        setSubmitPrompt("Recording...")
    }
    
    const stopConListen = () => {
        SpeechRecognition.stopListening();
        setSubmitPrompt(transcript)
        resetTranscript()
    }

    const retainPrompt = () => {
        try {
            localStorage.setItem("Generate", JSON.stringify({
                prompt: submitPrompt,
                enhancePrompt: enhancePrompt,
                seed: seed,
                negativeKeywords: negativeKeywords,
                steps: steps,
                guidance: guidance,
                imageCount: imageCount,
                imageWidth: imageWidth,
                imageHeight: imageHeight,
                selectedModel: selectedModel,
                selectedScheduler: selectedScheduler,
                tile: tile,
                shuffle: shuffle,
                upscale: upscale
            }))
        } catch (error) {
            console.error("Error saving prompt: ", error)
        }
    }

    useEffect(() => {
        if (onceTime === false) {
            // retainPrompt()
            setOnceTime(true)
        } else {
            retainPrompt()
        }
    },[submitPrompt, enhancePrompt, seed, negativeKeywords, steps, guidance, imageCount, imageWidth, imageHeight, selectedModel, selectedScheduler, tile, shuffle, upscale])

    const handleInput = (e) => {
        let text = e.currentTarget.textContent;
    // Allow numbers and a single decimal point
        let numericText = text.replace(/[^0-9.]/g, '');

        // Ensure only one decimal point is present
        const decimalParts = numericText.split('.');
        if (decimalParts.length > 2) { // More than one decimal point
            numericText = `${decimalParts[0]}.${decimalParts.slice(1).join('')}`;
        }

        console.log("numericText", numericText);
         // Handle the negative sign
        if (numericText.includes('-')) {
            // Keep only the first occurrence of '-', and only if it's at the start
            numericText = numericText.charAt(0) === '-' ? `-${numericText.replace(/-/g, '')}` : numericText.replace(/-/g, '');
        }

        // Update the text content if non-digits were removed
        if (text !== numericText) {
            e.currentTarget.textContent = numericText;
        }
        let number = Number(numericText);
        // Update state with the numeric text
        if (e.target.id === 'steps_span') {
            if (number > 100) {
                number = 100;                
            } else if (number < 0) {
                number = 0;
            }
            console.log("number", number);
            setSteps(number);
        } else if (e.target.id === 'guidance_span') {
            if (number > 20) {
                number = 20;                
            } else if (number < 0) {
                number = 0;
            }
            setGuidance(number);
        } else if (e.target.id === 'weight_span') {
            if (number > 3) {
                number = 3;
            } else if (number < -3) {
                number = -3;
            }
            setLoraWeight(number);
        }
        moveCaretToEnd(e.currentTarget);
    };
    
    const moveCaretToEnd = (element) => {
        const range = document.createRange();
        const sel = window.getSelection();
        range.selectNodeContents(element);
        range.collapse(false);
        sel.removeAllRanges();
        sel.addRange(range);
        element.focus();
    };


    const handleRecommendedSettings = async (model = selectedModel) => {
        //console.log(db.table('recommendedSettings').schema.indexes)
        //console.log(typeof selectedModel)
        setSelectedModel(model)

        try {
            const settings = await db.recommendedSettings.where("model").equals(String(model)).first();

            if (settings) {
                console.log(settings);
                setSteps(settings.steps);
                setGuidance(settings.guidance);
                // setImageCount(settings.imageCount);
                setImageWidth(settings.imageWidth);
                setImageHeight(settings.imageHeight);
                setSelectedModel(settings.model);
                setSelectedScheduler(settings.scheduler);
                setTile(settings.tile);
                setShuffle(settings.shuffle);
                setUpScale(settings.upscale);
            } else {
                // setImageCount(1);
                setImageWidth(512)
                setImageHeight(512)
                setGuidance(7.5)
                setSteps(12)
                setSelectedScheduler("DPM-Solver")
                setTile(false);
                setShuffle(false);
                setUpScale("0");
                console.log("No settings found for the model:", model);
            }
        } catch (error) {
            console.error("Failed to retrieve settings:", error);
        }


    };

    const currentModelSelected = () => {
        return { value: selectedModel, label: selectedModel }
    }

    useEffect(() => {
        if (!promptusAPIState.models.includes(selectedModel) && promptusAPIState.models.length > 0) {
            setSelectedModel(promptusAPIState.models[0]); // Sets to the first model available if the current selectedModel is not valid
        }
    }, [promptusAPIState.models, selectedModel]);


    useEffect(() => {
        if (selectedModel) {
            handleRecommendedSettings();
        }
    }, [selectedModel, props.fetchingUndelivered]); // This useEffect will now trigger anytime `selectedModel` changes

    const handleSetSeed = (value) => {
        if (value.length <= 19) {
            setSeed(value);
        }
    }

    const setMemePromptOptions = (memePrompt) => {
        setMemePrompt(memePrompt)
        console.log("setting model")
        if (promptusAPIState.online && memePrompt) {
            setSettingsOpen(false)
            setSelectedModel("(aimlapi) FLUX.1 schnell");
        }
    };

    const handleEscapeKey = (e) => {
        console.log("Key pressed: ", e);
        
        if (e.key === "Escape") {
            setOpenHistory(false)
        }
    }

    useEffect(() => {
        if (openHistory) {
            window.addEventListener('keydown', handleEscapeKey);
        }

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleEscapeKey);
        };
    }, [openHistory]);

    const clearHistory = async() => {
        console.log("Clear History");
        await db.transaction('rw', db.history, async () => {
            await db.history.clear();
        })
        .then(() => {
            Swal.fire({
                title: 'History Cleared Succesfully',
                timer: 2000,
                showConfirmButton: false
            })
            setOpenHistory(false)
        })   
    }

    return (
        <header className={`${driverContext.isActive ? '': 'sticky'} top-0 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-9 gap-2 m-2 mt-4 z-10`} onKeyDown={handleKeyDown}>
            {generateStatus.status === 'canceling' ? <div className={"w-full col-span-3 md:col-span-5 lg:col-span-9 text-white bg-red-900 rounded-lg p-4"}>Cancelling Prompt</div> : null}
            {(generateStatus.status === 'error' && generateStatus.message) ? <div className={"w-full col-span-3 md:col-span-5 lg:col-span-9 text-white bg-red-900 rounded-lg p-4"}>{generateStatus.message}</div> : null}
            <div className="flex flex-col lg:col-span-5 md:flex-row md:col-span-9 gap-2 md:gap-0">
                <label className="sr-only" htmlFor="prompt">Enter your Prompt</label>
                <input type="text" name="prompt" value={submitPrompt} onChange={(e) => setSubmitPrompt(e.target.value)}
                       onKeyUp={(e) => (e.key === 'Enter' && !generateStatus.loading) ? handleSubmitPrompt() : null}
                       className="text-xl w-full rounded-lg md:rounded-tr-none md:rounded-br-none py-3 px-5 text-dark-blue shadow-xl border-0"
                       id="prompt"
                       placeholder="Enter your prompt here..." disabled={generateStatus.loading} required />
                {!browserSupportsSpeechRecognition ? 
                    null 
                : 
                    // <></>
                    <div id="record" className="h-full">
                        {!listening ?
                            <button  className={"bg-white text-dark-blue text-4xl h-full"} onClick={() => {conListen()}} >
                                <img className="h-full" src={RecordingIcon} alt="Record Icon" />
                            </button>
                        :
                            <button className={"bg-white text-dark-blue text-4xl h-full"} onClick={() => {stopConListen()}} >
                                <img className="h-full" src={StopRecordingIcon} alt="Stop Record Icon" />
                            </button>
                        }       
                    </div>       
                }                       

                <button id="history" className={"bg-white text-dark-blue text-4xl h-full px-2"} onClick={() => setOpenHistory(true)}>
                    <img src={HistoryIcon} alt='Open History' className='h-14'/>
                </button>
                <ImageUpload image={image} setImage={setImage} overlayImage={maskImage} setPromptFile={openFile} />
                {!generateStatus.loading ? <>
                    <button id="edit" className={"bg-gray-500 text-white text-4xl h-full px-2"} onClick={() => setInPaint(true)}>
                        <img src={PencilIcon} alt='Paint Mask' className='h-14'/>
                    </button>
                </> : null}
                {generateStatus.loading || generateStatus.status === "generate" ?
                    <button type="submit" onClick={() => {
                        props.cancelPrompt();
                    }}
                            className={`rounded-lg md:rounded-tl-none md:rounded-bl-none bg-red-800 py-3 px-5 shadow-xl font-bold text-xl uppercase}`}>Cancel
                    </button>
                    :
                    <button type="submit" onClick={handleTagModal} id="generate"
                            className={`rounded-lg md:rounded-tl-none md:rounded-bl-none bg-yellow py-3 px-5 shadow-xl ${listening ? 'pointer-events-none': null} ${props.fetchingUndelivered? 'opacity-80 pointer-events-none' : null} font-bold text-xl uppercase`}>Generate
                    </button>
                }
                <button className="flex flex-col lg:flex-row items-center justify-center w-20 rounded-lg font-bold ml-1 p-1 gap-2 group bg-white text-dark-purple transition"
                onClick={help}>
                    <img className={"block w-full"} src={HowToIconActive} alt={`Icon for Quick Tour`}/>
                </button>
            </div>

            <div id="enhance" className={"bg-dark-blue/30 flex flex-col 3xl:flex-row rounded-xl place-content-center place-items-center gap-2 px-2 max-h-min"}>
                <ToggleInput onChange={(e) => setEnhancePrompt(e.target.checked)} checked={enhancePrompt} disabled={generateStatus.loading} />
                <span className={`font-bold text-lg xl:whitespace-nowrap ${enhancePrompt ? 'text-yellow' : 'text-gray-400'} transition`}>Enhance Prompt</span>
            </div>
            <div id="meme"
                 className={"bg-dark-blue/30 flex flex-col 3xl:flex-row rounded-xl place-content-center place-items-center gap-2 px-2 max-h-min"}>
                <ToggleInput onChange={(e) => setMemePromptOptions(e.target.checked)} checked={memePrompt} disabled={generateStatus.loading}/>
                <span className={`font-bold text-lg xl:whitespace-nowrap ${memePrompt ? 'text-yellow' : 'text-gray-400'} transition`}>Meme Prompt</span>
            </div>
            <div id="online" className={"bg-dark-blue/30 flex col-span-1 flex-col 2xl:flex-row rounded-xl place-content-center place-items-center gap-2 px-2 max-h-min"}>
                <ToggleInput onChange={(e) => toggleOffline(e.target.checked)} checked={onlineState} disabled={generateStatus.loading} />
                <span className={`font-bold text-lg xl:whitespace-nowrap ${onlineState ? 'text-yellow' : 'text-gray-400'} transition`}>Online</span>
            </div>
            <div id="tokens" className={"bg-dark-blue/30 flex lg:col-span-1 md:col-span-6 flex-col 2xl:flex-row rounded-xl place-content-center place-items-center gap-2 px-5 py-1 max-h-min"}>
                {accountContext.loggedIn ? 
                    <img className="pr-2 w-12 md:w-10 cursor-pointer 2xl:border-r whitespace-nowrap 2xl:border-white md:bottom-0" src={AccountIcon} alt="Promptus Account Icon" onClick={() => navigate("/profile")}/>
                :
                    null
                }
                <div className="flex flex-row gap-2">
                    <img src={TokenIcon} alt={"Promptus Token Icon"} />
                    <span className={"font-bold text-lg whitespace-nowrap"}>
                        {accountContext.loggedIn ? accountContext.tokens : 0}
                    </span>
                </div>

            </div>
            <div className={`bg-dark-blue/30 rounded-xl col-span-3 md:col-span-9 lg:col-span-9 px-5 backdrop-blur h-auto transition`}>
                <button className={`w-full flex flex-row items-center justify-center gap-2 text-lg transition duration-300 p-1 lg:p-2`} onClick={handleAdvancedSettings} disabled={generateStatus.loading}>Advanced Settings:<span className="text-yellow font-bold capitalize">{controlnetDisplay}</span> 
                <span className={`text-yellow font-bold capitalize ${imageNets === "" ? 'hidden' : ''}`}>{imageNets}</span> 
                <img className={`${settingsOpen ? 'rotate-0' : 'rotate-180'} transition duration-300`} src={AdvancedSettingsIcon} alt={"Advanced Settings Icon"} /></button>
            </div>
            <div className={`bg-dark-blue/30 rounded-xl col-span-3 md:col-span-9 ${driverContext.isActive ? '' : 'backdrop-blur'}`}>
                <AnimatePresence initial={false}>
                    {settingsOpen && (
                        <motion.div
                            animate="open"
                            initial="collapsed"
                            variants={{
                                open: { opacity: 1, height: "auto", },
                                collapsed: { opacity: 0, height: 0, }
                            }}
                            exit={"collapsed"}
                            transition={{ duration: 0.2, ease: [0.04, 0.62, 0.23, 0.98] }}
                            className={`grid gap-2 grid-cols-2 md:grid-cols-4 lg:grid-cols-10 lg:grid-rows-2 mt-1 lg:mt-2`}>
                            <AnimatedInputGroup
                                id="seeds" 
                                className={`col-span-2 ${driverContext.isActive ? 'text-black' : ''}`}
                            >
                                <label className="block mb-2 text-sm font-medium" htmlFor="seedValue">Seed</label>
                                <input type="text" name="seedValue" value={seed} onChange={(e) => handleSetSeed(e.target.value)}
                                       className={`w-full rounded-lg text-dark-blue ${driverContext.isActive ? 'border border-blue-950' : 'border-0'} p-2`}
                                       placeholder="Seed #"/>
                            </AnimatedInputGroup>
                            <AnimatedInputGroup
                                id="negative"
                                className={`col-span-2 ${driverContext.isActive ? 'text-black' : ''}`}>
                                <label className="block mb-2 text-sm font-medium" htmlFor="negativeKeywords">Negative keywords</label>
                                <input type="text" name="negativeKeywords" value={negativeKeywords} onChange={(e) => setNegativeKeywords(e.target.value)}
                                       className={`w-full rounded-lg text-dark-blue ${driverContext.isActive ? 'border border-blue-950' : 'border-0'} p-2`}
                                       placeholder="Enter negative keywords"/>
                            </AnimatedInputGroup>
                            <AnimatedInputGroup id="steps">
                                <label htmlFor="Steps"
                                       className={`w-full flex flex-row gap-4 items-center mb-2 text-sm font-medium ${driverContext.isActive ? 'text-black' : ''}`}>
                                    <span>Steps</span>
                                    <span id="steps_span" contentEditable={true}
                                        suppressContentEditableWarning={true}
                                        onInput={handleInput}    
                                        className={`block flex-grow bg-white px-2 py-1 rounded text-dark-blue text-right ${driverContext.isActive ? 'border border-blue-950' : ''}`}>{steps}</span>
                                </label>
                                <input id="Steps" type="range" value={steps} min={0} max={100} onChange={(e) => setSteps(Number(e.target.value))}
                                       className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none accent-yellow cursor-pointer" />
                            </AnimatedInputGroup>
                            <AnimatedInputGroup id="guidance">
                                <label htmlFor="Guidance"
                                       className={`w-full flex flex-row gap-4 items-center mb-2 text-sm font-medium ${driverContext.isActive ? 'text-black' : ''}`}>
                                    <span>Guidance</span>
                                    <span id="guidance_span" contentEditable={true}
                                        suppressContentEditableWarning={true}
                                        onInput={handleInput}  
                                        className={`block flex-grow bg-white px-2 py-1 rounded text-dark-blue text-right ${driverContext.isActive ? 'border border-blue-950' : ''}`}>{guidance}</span>
                                </label>
                                <input id="Guidance" type="range" value={guidance} step={0.5} min={0} max={20} onChange={(e) => setGuidance(Number(e.target.value))}
                                       className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none accent-yellow cursor-pointer" />
                            </AnimatedInputGroup>
                            <AnimatedInputGroup id="number">
                                <label htmlFor="NumImages"
                                       className={`block mb-2 text-sm font-medium ${driverContext.isActive ? 'text-black': ''}`}>No. of Images</label>
                                <input id="NumImages" type="number" value={imageCount} min={1} onChange={(e) => {
                                    if (Number(e.target.value) > 0) setImageCount(Math.ceil(Number(e.target.value)));
                                }}
                                className={`w-full rounded-lg text-dark-blue ${driverContext.isActive ? 'border border-blue-950' : 'border-0'} p-2`} />
                            </AnimatedInputGroup>
                            <AnimatedInputGroup
                                id="size"
                                className={`col-span-2 ${driverContext.isActive ? 'text-black' : ''}`}>
                                <label
                                    className="block mb-2 text-sm font-medium">Image size (Width x Height)</label>
                                <div>
                                    <input id="ImageWidth" type="number" value={imageWidth} step={8} onChange={(e) => setImageWidth(Number(e.target.value))}
                                           className={`w-1/2 rounded-tl-xl rounded-bl-xl text-dark-blue border-r-2 border-r-gray-200 p-2 text-right ${driverContext.isActive ? 'border border-blue-950' : ''}`} />
                                    <input id="ImageHeight" type="number" value={imageHeight} step={8} onChange={(e) => setImageHeight(Number(e.target.value))}
                                           className={`w-1/2 rounded-tr-xl rounded-br-xl text-dark-blue ${driverContext.isActive ? 'border border-blue-950' : 'border-0'} p-2`} />
                                </div>
                            </AnimatedInputGroup>
                            <AnimatedInputGroup
                                id="model"
                                className={`relative col-span-2 ${driverContext.isActive ? 'text-black' : ''}`}
                            >
                                <label htmlFor={"Model"}
                                       className="block mb-2 text-sm font-medium">Model</label>
                                <Select defaultValue={currentModelSelected} options={options} components={animatedComponents} onChange={(e) => handleRecommendedSettings(e.value)} className="text-dark-blue"/>
                                {/* <select id={"Model"} value={selectedModel} onChange={(e) => handleRecommendedSettings(e.target.value)}
                                        className={`w-full rounded-lg text-dark-blue ${driverContext.isActive ? 'border border-blue-950' : 'border-0'} p-2`}>
                                    {promptusAPIState.models.map((model, m) => <option key={`model_${m}`}>{model}</option>)}
                                </select> */}
                                <img className="absolute top-9 right-5 w-6" src={RefreshIcon} onClick={fetchModels}/>
                            </AnimatedInputGroup>
                            <AnimatedInputGroup
                                id="lora"
                                className={`col-span-2 ${driverContext.isActive ? 'text-black' : ''}`}
                            >
                                <label htmlFor={"Lora"}
                                       className="block mb-2 text-sm font-medium">LoRA</label>
                                <select id={"Lora"} value={selectedLora} onChange={(e) => setSelectedLora(e.target.value)}
                                        className={`w-full rounded-lg text-dark-blue ${driverContext.isActive ? 'border border-blue-950' : 'border-0'} p-2`}>
                                        <option key={`lora_none`}>None</option>    
                                    {promptusAPIState.loras.map((lora, m) => <option key={`lora_${m}`}>{lora}</option>)}
                                </select>
                            </AnimatedInputGroup>
                            <AnimatedInputGroup id="lora_weight">
                                <label htmlFor="Weight"
                                       className={`w-full flex flex-row gap-4 items-center mb-2 text-sm font-medium ${driverContext.isActive ? 'text-black' : ''}`}>
                                    <span>LoRA Weight</span>
                                    <span id="weight_span" contentEditable={true}
                                        suppressContentEditableWarning={true}
                                        onInput={handleInput} 
                                     className={`block flex-grow bg-white px-2 py-1 rounded text-dark-blue text-right ${driverContext.isActive ? 'border border-blue-950' : ''}`}>{loraWeight}</span>
                                </label>
                                <input id="Weight" type="range" value={loraWeight} min={-3} max={3} step={0.1} onChange={(e) => setLoraWeight(Number(e.target.value))}
                                       className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none accent-yellow cursor-pointer" />
                            </AnimatedInputGroup>
                            <AnimatedInputGroup
                                id="scheduler"
                                className={`col-span-2 ${driverContext.isActive ? 'text-black' : ''}`}
                            >
                                <label htmlFor={"Scheduler"}
                                       className="block mb-2 text-sm font-medium">Scheduler</label>
                                <select id={"Scheduler"} value={selectedScheduler} onChange={(e) => setSelectedScheduler(e.target.value)}
                                        className={`w-full rounded-lg text-dark-blue ${driverContext.isActive ? 'border border-blue-950' : 'border-0'} p-2`}>
                                    {schedulerOptions.map((scheduler, s) => <option key={`scheduler_${s}`}>{scheduler}</option>)}
                                </select>
                            </AnimatedInputGroup>
                            <AnimatedInputGroup
                                id="tileshuffle"
                                className={"col-span-2 flex place-items-center justify-center"}>
                                <div className={"flex flex-col md:flex-row gap-2"}>
                                    <div className={"flex flex-row items-center"}>
                                        <ToggleInput id={"Tile"} onChange={(e) => setTile(e.target.checked)} checked={tile} />
                                        <label htmlFor={"Tile"}
                                               className={`inline-block ml-2 text-sm font-medium ${tile ? 'text-yellow' : 'text-gray-400'} transition`}>Tile</label>
                                    </div>
                                    <div className={"flex flex-row items-center"}>
                                        <ToggleInput id={"Shuffle"} onChange={(e) => setShuffle(e.target.checked)} checked={shuffle} />
                                        <label htmlFor={"Shuffle"}
                                               className={`inline-block ml-2 text-sm font-medium ${shuffle ? 'text-yellow' : 'text-gray-400'} transition`}>Shuffle</label>
                                    </div>
                                </div>
                            </AnimatedInputGroup>
                            <AnimatedInputGroup id="scale">
                                <label htmlFor="UpScale"
                                       className={`w-full flex flex-row gap-4 items-center mb-2 text-sm font-medium ${driverContext.isActive ? 'text-black' : ''}`}>
                                    <span>Scale</span>
                                    <span className={`block flex-grow bg-white px-2 py-1 rounded text-dark-blue text-right ${driverContext.isActive ? 'border border-blue-950' : ''}`}>{upscale}X</span>
                                </label>
                                <input id="UpScale" type="range" value={upscale} step={2} min={0} max={8} onChange={(e) => handleUpscale(e.target.value)}
                                       className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none accent-yellow cursor-pointer" />
                            </AnimatedInputGroup>
                            {image ?
                            <AnimatedInputGroup
                                className={"col-span-8 flex flex-col items-center justify-between"}>
                                <div className={"flex flex-col md:flex-row gap-2 w-full"}>
                                    <div id="imgtoimg" className={"flex flex-row items-center flex-grow"}>
                                        <ToggleInput id={"imageImage"} onChange={(e) => {
                                            if (e.target.checked) {
                                                setPromptOutput("image-image");
                                                setUpScale(0)
                                                setControlNet("");
                                                setPix2Pix(false);
                                            } else {
                                                setPromptOutput("text-image");
                                                setImageNets("")
                                            }
                                        }} checked={promptOutput === "image-image"} />
                                        <label htmlFor={"imageImage"}
                                               className={`inline-block ml-2 text-sm font-medium ${promptOutput === "image-image" ? 'text-yellow' : 'text-gray-400'} transition`}>Image to Image</label>
                                    </div>
                                    <div id="inimg" className={"flex flex-row items-center flex-grow"}>
                                        <ToggleInput id={"imageInPaint"} onChange={(e) => {
                                            if (e.target.checked) {
                                                setPromptOutput("image-in-paint")
                                                setUpScale(0)
                                                setControlNet("");
                                                setPix2Pix(false);
                                            } else {
                                                setPromptOutput("text-image");
                                                setImageNets("")
                                            }
                                        }} checked={promptOutput === "image-in-paint"} />
                                        <label htmlFor={"imageInPaint"}
                                               className={`inline-block ml-2 text-sm font-medium ${promptOutput === "image-in-paint" ? 'text-yellow' : 'text-gray-400'} transition`}>In-Paint Image</label>
                                    </div>
                                    <div id="guided" className={"flex flex-row items-center"}>
                                        <ToggleInput id={"Pix2Pix"} onChange={(e) => {
                                            setControlNet("");
                                            setPix2Pix(e.target.checked);
                                            setUpScale(0)
                                            setPromptOutput("text-image");
                                            setImageNets("Guided")
                                            setSelectedModel("instruct-pix2pix")
                                            if (!e.target.checked) {
                                                setImageNets("")
                                            }
                                        }} checked={pix2pix} />
                                        <label htmlFor={"Pix2Pix"}
                                               className={`inline-block ml-2 text-sm font-medium ${pix2pix ? 'text-yellow' : 'text-gray-400'} transition`}>Guided</label>
                                    </div>
                                    <div className={"flex flex-col w-full p-2 border rounded"}>
                                        <div className={"text-xs py-2"}>Control Nets</div>
                                        <div className={"flex flex-row gap-2"}>
                                            <div id="pose" className={"flex flex-row items-center"}>
                                                <ToggleInput id={"PoseToImage"} onChange={(e) => handleControlNetToggle(e.target.checked, "pose-to-image")} checked={(controlNet === "pose-to-image")} />
                                                <label htmlFor={"PoseToImage"}
                                                       className={`inline-block ml-2 text-sm font-medium ${controlNet === "pose-to-image" ? 'text-yellow' : 'text-gray-400'} transition`}>Pose to Image</label>
                                            </div>
                                            <div id="canny" className={"flex flex-row items-center"}>
                                                <ToggleInput id={"Canny"} onChange={(e) => handleControlNetToggle(e.target.checked, "canny")} checked={(controlNet === "canny")} />
                                                <label htmlFor={"Canny"}
                                                       className={`inline-block ml-2 text-sm font-medium ${controlNet === "canny" ? 'text-yellow' : 'text-gray-400'} transition`}>Canny</label>
                                            </div>
                                            <div id="scribble" className={"flex flex-row items-center"}>
                                                <ToggleInput id={"Scribble"} onChange={(e) => handleControlNetToggle(e.target.checked, "scribble")} checked={(controlNet === "scribble")} />
                                                <label htmlFor={"Scribble"}
                                                       className={`inline-block ml-2 text-sm font-medium ${controlNet === "scribble" ? 'text-yellow' : 'text-gray-400'} transition`}>Scribble</label>
                                            </div>
                                            <div id="straight" className={"flex flex-row items-center"}>
                                                <ToggleInput id={"StraightLines"} onChange={(e) => handleControlNetToggle(e.target.checked, "mlsd")} checked={(controlNet === "mlsd")} />
                                                <label htmlFor={"StraightLines"}
                                                       className={`inline-block ml-2 text-sm font-medium ${controlNet === "mlsd" ? 'text-yellow' : 'text-gray-400'} transition`}>Straight Lines</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AnimatedInputGroup>
                                : null}
                            {!generateStatus.loading ?
                                <AnimatedInputGroup
                                    className={"flex place-items-center justify-center lg:row-span-2"}
                                >
                                    <button className={"border-2 rounded uppercase px-5 py-2 bg-white/20 font-bold m-1"} onClick={handleClearParams}>clear</button>
                                </AnimatedInputGroup>
                            : null }
                        </motion.div>)}
                </AnimatePresence>
            </div>
            {inPaint ?
            <div className={"fixed top-0 left-0 z-10 flex flex-col justify-center place-items-center h-screen w-screen bg-dark-blue/40 backdrop-blur"}>
                <div className={"w-full mx-auto max-w-screen-lg bg-gray-500/50 flex flex-row justify-end"}>
                    <button className={"px-5 py-2 rounded bg-dark-blue text-white m-2 hover:text-yellow transition"} onClick={() => setInPaint(false)}>
                        <img src={CloseIcon} alt='Close Image' className='h-7'/>
                    </button>
                </div>
                <DrawingInput image={`data:image/*;base64,${image}`} isMask={!!image} setImage={image ? setMaskImage : setImage} closeEvent={() => setInPaint(false)} />
            </div>: null}
            {openHistory ?
                <div className={"fixed top-0 left-0 z-10 flex flex-col justify-center place-items-center h-screen w-screen bg-dark-blue/40 backdrop-blur"}>
                    <div className={"w-full mx-auto max-w-screen-lg bg-gray-500/50 flex flex-row justify-between items-center"}>
                        <h1 className={"text-2xl text-white px-4 font-bold drop-shadow"}>Prompt History</h1>
                        <div className="flex flex-row">
                            <button className={"py-2 px-4 m-2 rounded bg-red-600 transition"} onClick={clearHistory}>Delete All</button>
                            <button className={"px-5 py-2 rounded bg-dark-blue text-white m-2 hover:text-yellow transition"} onClick={() => setOpenHistory(false)}>
                                <img src={CloseIcon} alt='Close Image' className='h-7'/>
                            </button>
                        </div>
                    </div>
                    <PromptHistory setPrompt={setWholePrompt} closeEvent={() => setOpenHistory(false)} setSeedWithPrompt={setSeedPrompt}/>
                </div>
                : null}
                <Modal open={open} onClose={() => setOpen(false)} center >
                    <h2 className="text-2xl mb-5 font-bold">Tag</h2>
                    <p>
                        Please type in a tag to easily sort out your images
                    </p>
                    <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                        <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">New Tag</label>
                        <input type="text" name="tag" className="w-full rounded-lg text-dark-blue border border-dark-blue p-2" placeholder="Tag"
                        value={inputTag} onChange={(e) => setInputTag(e.target.value)}/>
                    </div>
                    <div className="flex flex-row items-center">
                        <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                        <h1 className="mx-4 font-bold text-xl">OR</h1>
                        <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                    </div>
                    <p>
                        Please select an existing tag to easily sort out your images
                    </p>
                    <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                        <label className="block mb-2 text-sm font-medium" htmlFor="existing">Existing Tag</label>
                        <select name="existing" className={"rounded-lg text-dark-blue border border-dark-blue p-2 w-full"} value={tag} onChange={(e) => setTag(e.target.value)}>
                            <option></option>
                            {collectionContext.tags.map((category, i) => <option key={i} value={`${category}`}>{category}</option>)}
                        </select>
                    </div>
                    <div className="flex flex-row justify-center gap-4">
                        <button onClick={addTagToImage} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">Categorize</button>
                        <button onClick={() => setOpen(false)} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-dark-blue text-yellow shadow font-bold">Cancel</button>
                    </div>
                </Modal>
        </header>

    );
}

export function helpOverlays(e, driver){
    // Help Overlay
    e.stopPropagation();

    const steps = [
        {
            // Step 1
            element: '#prompt',
            popover: {
                title: 'Prompt Input',
                description: 'You will type in a prompt to generate an image with this input.',
                position: 'bottom'
            }
        },
        {// Step 2
            element: '#record',
            popover: {
                title: 'Record',
                description: 'This button will be used to record your voice for a voice prompt then after stopping the recording you will be given the chance to edit anything in the prompt input before generating',
                position: 'bottom'
            }
        },
        {// Step 3
            element: '#history',
            popover: {
                title: 'History',
                description: 'This button will show the history of other inputs you have made',
                position: 'bottom'
            }
        },
        {// Step 4
            element: '#upload',
            popover: {
                title: 'Upload',
                description: 'Here you can upload a image you have generated or an image of your own',
                position: 'bottom'
            }
        },
        {// Step 5
            element: '#edit',
            popover: {
                title: 'Masking',
                description: 'Here you will add a mask to your uploaded image to add/change whatever is in your mask',
                position: 'bottom'
            }
        },
        {// Step 6
            element: '#generate',
            popover: {
                title: 'Generate',
                description: 'Once you are finish with making your prompt, clicking this button will start generating your prompt',
                position: 'bottom'
            }
        },
        {// Step 7
            element: '#enhance',
            popover: {
                title: 'Enhance Prompt',
                description: 'This toggle will make your prompt more detailed to generate a more detailed image',
                position: 'bottom'
            }
        },
        {
            element: '#meme',
            popover: {
                title: 'Meme Prompt',
                description: 'This toggle will turn your prompt into a meme styled image',
                position: 'bottom'
            }
        },        
        {
                element: '#online',
                popover: {
                    title: 'Online/Offline Toggle',
                    description: 'This toggle will switch you to online or offline depending on what you would like to generate on',
                    position: 'bottom'
                }
        },
        {// Step 9
                element: '#tokens',
                popover: {
                    title: 'Tokens',
                    description: 'The tokens decreases everytime you successfully generate a image and you buy tokens to generate more images',
                    position: 'left'
                }
            },
            {// Step 10
                element: '#seeds',
                popover: {
                    title: 'Seeds',
                    description: 'A unique seed number that is generated for each result of the prompt generated.',
                    position: 'bottom'
                }
            },
            {// Step 11
                element: '#negative',
                popover: {
                    title: 'Negative Keywords',
                    description: 'Negative keywords refer to specific terms or phrases that you want to exclude from the generated images. ',
                    position: 'bottom'
                }
            },
            {// Step 12
                element: '#steps',
                popover: {
                    title: 'Steps',
                    description: 'This slider will indicate how detailed you want the image to be the higher you go',
                    position: 'bottom'
                }
            },
            {// Step 13
                element: '#guidance',
                popover: {
                    title: 'Guidance',
                    description: 'This Guidance Scale is a measurement tool used to assess the level of complexity and abstractness of the generated images.This scale ranges from 0 to 20, with higher numbers indicating more complex and abstract images.',
                    position: 'bottom'
                }
            },
            {// Step 14
                element: '#number',
                popover: {
                    title: 'Number Of Images',
                    description: 'You can specify the number of images you would like to generate. This can range from 1 to a large number, depending on the processing power of the source and your preferences.',
                    position: 'bottom'
                }
            },
            {// Step 15
                element: '#size',
                popover: {
                    title: 'Image Size',
                    description: 'You can specify the image size you would like the images to be generated at.',
                    position: 'bottom'
                }
            },
            {// Step 16
                element: '#model',
                popover: {
                    title: 'Models',
                    description: 'The Model is a component of the AI image creation system that selects and processes data to generate images. It samples data from various sources, including image databases, algorithms, and user input, to produce final images. The Model is crucial in determining the quality, complexity, and overall appearance of the generated images and can vary in terms of quality and generation speed based on the algorithms and data sources used.',
                    position: 'bottom'
                }
            },
            {// Step 17
                element: '#scheduler',
                popover: {
                    title: 'Scheduler',
                    description: 'Schedulers can affect the final image generated by controlling how the model is trained during the image generation process. They essentially control the learning rate or step size of the model as it improves over time, and determine how quickly or slowly the model is allowed to learn and adapt to new data. ',
                    position: 'bottom'
                }
            },
            {// Step 18
                element: '#tileshuffle',
                popover: {
                    title: 'Tile and Shuffle',
                    description: 'When tile is enabled, images are generated as s repeatable pattern and when shuffle is enabled, an AI model is randomly selected when images are generated.',
                    position: 'bottom'
                }
            },
            {// Step 19
                element: '#scale',
                popover: {
                    title: 'Scale',
                    description: 'You can scale an uploaded image by 2/4/8 times it\'s original size',
                    position: 'bottom'
                }
            },
            {// Step 21
                element: '#imgtoimg',
                popover: {
                    title: 'Image To Image',
                    description: 'Using an uploaded image you can change this image using it as the base and the prompt will change it however you want it to',
                    position: 'bottom'
                }
            },
            {// Step 22
                element: '#inimg',
                popover: {
                    title: 'In-Paint Image',
                    description: 'Using the mask on an image or using a scribble, in-painting will fill in the missing parts of the image using your prompt as the missing part to present a complete image',
                    position: 'bottom'
                }
            },
            {// Step 23
                element: '#guided',
                popover: {
                    title: 'Guided',
                    description: 'Guided uses the image uploaded and the masking on it to edit the part of the image you masked with the prompt',
                    position: 'bottom'
                }
            },
            {// Step 24
                element: '#pose',
                popover: {
                    title: 'Pose To Image',
                    description: 'This control net maps a human pose of the input image and uses that pose in correspondence with the prompt to create an image with similar poses to the base image',
                    position: 'bottom'
                }
            },
            {// Step 25
                element: '#canny',
                popover: {
                    title: 'Canny',
                    description: 'Canny uses edge detection on your input image and creates a new image with your prompt using the edges it detected',
                    position: 'bottom'
                }
            },
            {// Step 26
                element: '#scribble',
                popover: {
                    title: 'Scribble',
                    description: 'Scribble uses the scribble you made in the mask area or an uploaded scribble and it will use your drawing and prompt as a template to guide the generation',
                    position: 'bottom'
                }
            },
            {// Step 27
                element: '#straight',
                popover: {
                    title: 'Straight Lines',
                    description: 'This control net uses line detection in an input image in addition to a prompt to generate an image',
                    position: 'bottom'
                }
            }
        ] ;


    // Define the steps in the driver
    driver.defineSteps(steps);
};